import React, {
    useState,
    useEffect,
    Fragment,
  } from 'react';
  import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
  } from '@material-ui/core';
  import { CircleIcon } from '@material-ui/icons/Add'
  import { Auth } from 'aws-amplify';
  import { useHistory } from "react-router-dom";
  import { useTranslation } from 'react-i18next';
  import { makeStyles } from '@material-ui/core/styles';
  import {updateTimeStamp, updateNotes} from '../data';
  

  const useStyles = makeStyles((theme) => ({
    indented: {
      marginLeft: theme.spacing(0),
      marginTop: theme.spacing(1)
    },
    indented_subBullet: {
      marginLeft: theme.spacing(4),
    },
}));

  const UpdateNotification = ({ signedIn, showUpdate, onCloseFunction=()=>{} }) => {
    //let history = useHistory();
    const classes = useStyles();
    const { t, i18n } = useTranslation();
    let idleInterval = 1000 * 60 * 1;  //1 minute
    let idleEvent;
    const handleClose = () => {
      //Fetch to set that this update has been has been acknowledge
      onCloseFunction();
    };
  

    // change fragment to modal and handleclose func to close
    return <Fragment>
      <Dialog disableBackdropClick disableEscapeKeyDown open={showUpdate} onClose={handleClose}>
        <DialogTitle>
            {t("pulseLevelUpdated").replace("{date}",updateTimeStamp)}
        </DialogTitle>
        <DialogContent>
            {<Typography>{t("whatsNew")}:</Typography>}
            {updateNotes.map((note) => (<Typography 
                className={note.type === "sub" ? classes.indented_subBullet : classes.indented} 
                gutterBottom={true}>
                  {note.type === 'main' ? '\u25AA' : '\u25CB'} {note.label}
              </Typography>))}
        </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={handleClose} color="primary">
            {t("ok")}
          </Button>
        </DialogActions>
      </Dialog>
    </Fragment>;
  };
  
  export default UpdateNotification;